import React from "react";
import { Link } from "react-router-dom";
import "./styles/Profile.css";
import ProfileLayout from "../components/ProfileLayout";
import { ListSkeleton } from "../components/Skeleton";
import { connect } from "react-redux";
import * as actions from "../redux/actions/privacyActions";
import { Translate, I18n } from "react-redux-i18n";
import { FaArrowLeft } from "react-icons/fa";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

function PrivacyToggle({ item, onChange, saving }) {
  const isOn = item.value === "on";

  return (
    <li className="profile-privacy-item">
      <div className="profile-edit-toggle">
        <span className="profile-privacy-item__label">
          <Translate value={item.field} />
        </span>
        <label className="profile-edit-switch">
          <input
            type="checkbox"
            name={item.field}
            checked={isOn}
            disabled={saving}
            onChange={() => onChange(item.field)}
          />
          <span className="profile-edit-switch-slider" />
        </label>
      </div>
    </li>
  );
}

class ProfilePrivacy extends React.Component {
  state = {
    form: [],
    savingField: null,
  };

  componentDidMount() {
    this.fetchLoadPrivacy();
  }

  fetchLoadPrivacy = async () => {
    await this.props
      .LoadPrivacy(this.props.user_id, this.props.token)
      .then(() => {
        if (this.props.error) {
          alertify.warning(I18n.t(this.props.error));
        } else {
          this.setState({
            form: this.props.privacy || [],
          });
        }
      });
  };

  onChange = async (field) => {
    const item = this.state.form.find((entry) => entry.field === field);
    if (!item) return;

    const newValue = item.value === "on" ? "off" : "on";
    const previousForm = this.state.form;

    this.setState({
      savingField: field,
      form: this.state.form.map((entry) =>
        entry.field === field ? { ...entry, value: newValue } : entry
      ),
    });

    await this.props
      .UpdatePrivacy(
        this.props.token,
        field,
        newValue,
        this.props.user_id
      )
      .then(() => {
        if (this.props.error_update) {
          alertify.warning(I18n.t(this.props.error_update));
          this.setState({ form: previousForm });
        }
      })
      .finally(() => {
        this.setState({ savingField: null });
      });
  };

  render() {
    const { form, savingField } = this.state;
    const loading = this.props.loading && form.length === 0;

    return (
      <ProfileLayout>
        <div className="profile-data-page profile-edit-page">
          <div className="card profile-edit-card">
            <div className="profile-edit-header profile-data-header">
              <Link to="/profile" className="profile-edit-back" aria-label="Back">
                <FaArrowLeft />
              </Link>
              <div>
                <h3 className="profile-edit-title">
                  <Translate value="profile_privacy" />
                </h3>
                <p className="profile-edit-subtitle">
                  @{this.props.profile?.username || ""}
                </p>
              </div>
            </div>

            <div className="profile-edit-form">
              {loading ? (
                <ListSkeleton />
              ) : form.length === 0 ? (
                <div className="profile-privacy-empty">
                  <Translate value="try_later" />
                </div>
              ) : (
                <ul className="profile-privacy-list">
                  {form.map((item) => (
                    <PrivacyToggle
                      item={item}
                      key={item.field}
                      saving={savingField === item.field}
                      onChange={this.onChange}
                    />
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      </ProfileLayout>
    );
  }
}

function mapStateToProps(reducer) {
  return {
    user_id: reducer.session.auth.id,
    token: reducer.session.auth.access_token,
    profile: reducer.session.auth,

    privacy: reducer.privacy.list,
    error: reducer.privacy.error,
    loading: reducer.privacy.loading,
    success: reducer.privacy.success,
    error_update: reducer.privacy.error_update,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadPrivacy: (user_id, token) =>
    dispatch(actions.loadItem({ user_id, token })),
  UpdatePrivacy: (token, field, value, user_id) =>
    dispatch(actions.updateItem({ token, field, value, user_id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePrivacy);
